// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'inspect';

export const Component = () => (
  <path d='M24.33 2H2.155v12.548l1.15-.623V3.149H23.18v15.182H9.723l-.575 1.15H24.33V2ZM10.297 12.68.814 16.416l1.677 1.629L0 20.535l2.49 2.442 2.443-2.442 1.676 1.628 3.688-9.483ZM2.49 21.35l-.862-.815 1.484-1.437.144-.191.862-.862-1.198-1.197 5.317-2.107-2.06 5.364-1.245-1.246-.862.862-.144.192-1.436 1.436Z' />
);

export const viewBox = '0 0 25 25';
